<!-- <app-customer-header></app-customer-header> -->

<!-- <ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="square-jelly-box"
  [fullScreen]="true"
>
  <p style="color: white">please wait!..</p>
</ngx-spinner> -->
<section *ngIf="false" class="theme {{ shop_template }}">
  <div class="theme__nav">
    <div class="container-fluid">
      <img loading="lazy"
        class="logo"
        src="{{ imgUrl }}{{ shop_logo }}"
        *ngIf="shop_logo !== ''"
      />
      <img loading="lazy"
        class="logo"
        src="../../../assets/images/new/main.png"
        *ngIf="shop_logo == ''"
      />

      <div class="links">
        <div class="links__item" (click)="openCartPopup($event, cartPopup)">
          <i class="links__item--icon fa-solid fa-cart-shopping"></i>
          <span>CART</span>
        </div>
        <a
          class="links__item"
          [href]="'https://wa.me/' + w_phone_number"
          target="_blank"
          style="color: black"
        >
          <i class="links__item--icon fa-brands fa-whatsapp"></i>
          <span>WHATSAPP</span>
        </a>
        <div class="links__item" (click)="openInfoModal()">
          <i class="links__item--icon fa-solid fa-circle-info"></i>
          <span>INFO</span>
        </div>

        <div
          class="links__item"
          (click)="
            isLogin == 1
              ? openOrderHistoryPopup(orderHistoryPopup)
              : openShopSigninPopup(shopSigninPopup)
          "
          *ngIf="isLogin == 1"
        >
          <i class="links__item--icon fa-solid fa-clock-rotate-left"></i>
          <span>ORDER HISTORY</span>
        </div>
        <div
          class="links__item"
          (click)="openShopSigninPopup(shopSigninPopup)"
          *ngIf="isLogin == 0"
        >
          <i class="links__item--icon fa-solid fa-user"></i>
          <span>SIGN IN</span>
        </div>
        <!-- <div class="links__item" *ngIf="url_type == 'normal'">
<i
  class="fa-solid fa-user-plus"
  (click)="
    isLogin == 1
      ? openMemberLinkPopup(memberLinkPopup)
      : openShopSigninPopup(shopSigninPopup)
  "
></i>
<p>MEMBER LINKS</p>
</div> -->

        <div class="links__item my-dropdown" *ngIf="isLogin == 1" ngbDropdown>
          <i class="links__item--icon fa-solid fa-user"></i>
          <span ngbDropdownToggle>Profile</span>

          <div ngbDropdownMenu id="ProfileMenu">
            <button ngbDropdownItem>
              <i class="fa-solid fa-user"></i> Profile
            </button>
            <button
              (click)="openMemberLinkPopup(memberLinkPopup)"
              ngbDropdownItem
            >
              <i class="fa-regular fa-file-lines"></i> Referral
            </button>
            <button
              (click)="openShopSignoutPopup(shopSignoutPopup)"
              ngbDropdownItem
            >
              <i class="fa-solid fa-right-from-bracket"></i>
              Sign Out
            </button>
          </div>
        </div>
        <!-- <a nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu">
<span nz-icon nzType="caret-down"></span>
</a> -->
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu>
            <li nz-menu-item>
              <i class="fa-brands fa-whatsapp"></i>
              <span class="nzText">&nbsp;Whatsapp</span>
            </li>
            <li nz-menu-item>
              <i class="fa-solid fa-circle-info"></i>
              <span class="nzText">&nbsp;Information</span>
            </li>
            <li nz-menu-item>
              <i
                class="fa-solid fa-cart-shopping"
                (click)="openCartPopup($event, cartPopup)"
              ></i>
              <span
                class="nzText"
                (click)="
                  isLogin == 1
                    ? openCartPopup($event, cartPopup)
                    : openShopSigninPopup(shopSigninPopup)
                "
                >&nbsp;Cart</span
              >
            </li>
            <li nz-menu-item *ngIf="isLogin == 1">
              <i
                class="fa-solid fa-clock-rotate-left"
                (click)="
                  isLogin == 1
                    ? openOrderHistoryPopup(orderHistoryPopup)
                    : openShopSigninPopup(shopSigninPopup)
                "
              ></i>
              <span
                class="nzText"
                (click)="
                  isLogin == 1
                    ? openOrderHistoryPopup(orderHistoryPopup)
                    : openShopSigninPopup(shopSigninPopup)
                "
                >&nbsp;Order History</span
              >
            </li>
            <li nz-menu-item *ngIf="isLogin == 0">
              <i
                class="fa-solid fa-user"
                (click)="openShopSigninPopup(shopSigninPopup)"
              ></i>
              <span
                class="nzText"
                (click)="openShopSigninPopup(shopSigninPopup)"
                >&nbsp;Add Member</span
              >
            </li>
            <li nz-menu-item *ngIf="isLogin == 1">
              <i
                class="fa-solid fa-right-from-bracket"
                (click)="openShopSignoutPopup(shopSignoutPopup)"
              ></i>
              <span
                class="nzText"
                (click)="openShopSignoutPopup(shopSignoutPopup)"
                >&nbsp;Logout</span
              >
            </li>
            <li nz-menu-item *ngIf="url_type == 'normal'">
              <i
                class="fa-solid fa-user-plus"
                (click)="
                  isLogin == 1
                    ? openMemberLinkPopup(memberLinkPopup)
                    : openShopSigninPopup(shopSigninPopup)
                "
              ></i>
              <span
                class="nzText"
                (click)="
                  isLogin == 1
                    ? openMemberLinkPopup(memberLinkPopup)
                    : openShopSigninPopup(shopSigninPopup)
                "
                >&nbsp;Member Links</span
              >
            </li>
          </ul>
        </nz-dropdown-menu>
      </div>
    </div>
  </div>

  <div class="theme__nav_extra">
    <nz-tabset nzCentered>
      <nz-tab
        *ngFor="let tab of categories"
        [nzTitle]="tab.name"
        (nzClick)="tabChange(tab)"
      >
      </nz-tab>
    </nz-tabset>
  </div>

  <app-add-product-crousel-cust
    [local]="false"
    [images]="get_all_product_banner_response"
  ></app-add-product-crousel-cust>
  <div class="theme__products">
    <div class="container">
      <div class="theme__products--nav">
        <nz-tabset nzType="card">
          <nz-tab
            *ngFor="let sub of subcategories; index as i"
            [nzTitle]="sub.name"
            (nzClick)="subCatTabChange(sub); getProductList(sub.id, i)"
          >
          </nz-tab>
        </nz-tabset>
      </div>

      <div class="text-center coming_soon" *ngIf="filteredProductsLength == 0">
        <img loading="lazy" src="../../../assets/images/new/coming-soon.png" />
      </div>
      <div class="theme__products--grid">
        <ng-container *ngFor="let item of filteredProducts">
          <div
            class="card"
            *ngFor="let list of item"
            (click)="editProductModal(editProduct, list)"
          >
            <img loading="lazy" src="{{ imgUrl }}{{ list.primaryImage }}" />
            <div class="card--content">
              <div class="card--content__name">
                {{ list.name }}
              </div>
              <ng-container *ngFor="let img of list.foodImages">
                <img loading="lazy" src="{{ imgUrl }}{{ img.image }}" />
              </ng-container>
              <div class="card--content__price">${{ list.memberPrice }}</div>
              <div class="card--content__desc">
                {{ list.description.substr(0, 100)
                }}<span *ngIf="list.description.length > 100">...</span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="theme__nav-mobile">
    <div class="theme__nav-mobile--item">
      <i class="fa-brands fa-whatsapp icon"></i>
      <div class="text">Whatsapp</div>
    </div>
    <div class="theme__nav-mobile--item">
      <i class="fa-solid fa-circle-info icon"></i>
      <div class="text">Info</div>
    </div>
    <div
      class="theme__nav-mobile--item"
      (click)="openCartPopup($event, cartPopup)"
    >
      <i class="fa-solid fa-cart-shopping icon"></i>
      <div class="text">Cart</div>
    </div>
    <div
      class="theme__nav-mobile--item"
      (click)="
        isLogin == 1
          ? openOrderHistoryPopup(orderHistoryPopup)
          : openShopSigninPopup(shopSigninPopup)
      "
    >
      <i class="fa-solid fa-clock-rotate-left icon"></i>
      <div class="text">Purchases</div>
    </div>
    <div
      class="theme__nav-mobile--item"
      (click)="openShopSigninPopup(shopSigninPopup)"
      *ngIf="isLogin == 0"
    >
      <i class="fa-solid fa-user icon"></i>
      <div class="text">Sign In</div>
    </div>
    <div
      class="theme__nav-mobile--item my-dropdown"
      *ngIf="isLogin == 1"
      ngbDropdown
    >
      <div ngbDropdownToggle>
        <i class="fa-solid fa-user icon"></i>
        <div class="text">Profile</div>
        <div ngbDropdownMenu id="ProfileMenuMobile">
          <button ngbDropdownItem>
            <i class="fa-solid fa-user"></i> Profile
          </button>
          <button
            (click)="openMemberLinkPopup(memberLinkPopup)"
            ngbDropdownItem
          >
            <i class="fa-regular fa-file-lines"></i> Referral
          </button>
          <button
            (click)="openShopSignoutPopup(shopSignoutPopup)"
            ngbDropdownItem
          >
            <i class="fa-solid fa-right-from-bracket"></i>
            Sign Out
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="theme-2 {{ shop_template }}">
  <div class="theme-2__nav">
    <div class="container-fluid">
      <div class="theme-2__nav_extra">
        <nz-tabset>
          <nz-tab
            *ngFor="let tab of categories"
            [nzTitle]="tab.name"
            (nzClick)="tabChange(tab)"
          >
          </nz-tab>
        </nz-tabset>
      </div>
      <div class="links">
        <div class="links__item" (click)="openCartPopup($event, cartPopup)">
          <i class="links__item--icon fa-solid fa-cart-shopping"></i>
        </div>
        <a
          class="links__item"
          [href]="'https://wa.me/' + w_phone_number"
          target="_blank"
          style="color: black"
        >
          <i class="links__item--icon fa-brands fa-whatsapp"></i>
        </a>
        <div class="links__item" (click)="openInfoModal()">
          <i class="links__item--icon fa-solid fa-circle-info"></i>
        </div>

        <div
          class="links__item"
          (click)="
            isLogin == 1
              ? openOrderHistoryPopup(orderHistoryPopup)
              : openShopSigninPopup(shopSigninPopup)
          "
          *ngIf="isLogin == 1"
        >
          <i class="links__item--icon fa-solid fa-clock-rotate-left"></i>
        </div>
        <div
          class="links__item"
          (click)="openShopSigninPopup(shopSigninPopup)"
          *ngIf="isLogin == 0"
        >
          <i class="links__item--icon fa-solid fa-user"></i>
        </div>
        <div class="links__item my-dropdown" *ngIf="isLogin == 1" ngbDropdown>
          <i class="links__item--icon fa-solid fa-user" ngbDropdownToggle></i>
          <!-- <span ngbDropdownToggle>Profile</span> -->

          <div ngbDropdownMenu id="ProfileMenu">
            <button ngbDropdownItem>
              <i class="fa-solid fa-user"></i> Profile
            </button>
            <button
              (click)="openMemberLinkPopup(memberLinkPopup)"
              ngbDropdownItem
            >
              <i class="fa-regular fa-file-lines"></i> Referral
            </button>
            <button
              (click)="openShopSignoutPopup(shopSignoutPopup)"
              ngbDropdownItem
            >
              <i class="fa-solid fa-right-from-bracket"></i>
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-add-product-crousel-cust
    [local]="false"
    [images]="get_all_product_banner_response"
  ></app-add-product-crousel-cust>

  <div class="container">
    <div class="logo">
      <img loading="lazy" src="{{ imgUrl }}{{ shop_logo }}" *ngIf="shop_logo !== ''" />
      <img loading="lazy"
        src="../../../assets/images/new/main.png"
        *ngIf="shop_logo == ''"
      />
    </div>
  </div>

  <div class="theme-2__products">
    <div class="container">
      <div class="theme-2__products--nav">
        <nz-tabset nzType="card">
          <nz-tab
            *ngFor="let sub of subcategories; index as i"
            [nzTitle]="sub.name"
            (nzClick)="subCatTabChange(sub); getProductList(sub.id, i)"
          >
          </nz-tab>
        </nz-tabset>
      </div>

      <div class="text-center coming_soon" *ngIf="filteredProductsLength == 0">
        <img loading="lazy" src="../../../assets/images/new/coming-soon.png" />
      </div>
      <div class="theme-2__products--grid">
        <ng-container *ngFor="let item of filteredProducts">
          <div
            class="card"
            *ngFor="let list of item"
            (click)="editProductModal(editProduct, list)"
          >
            <img loading="lazy" src="{{ imgUrl }}{{ list.primaryImage }}" />
            <div class="card--content">
              <div class="card--content__name">
                {{ list.name }}
              </div>
              <ng-container *ngFor="let img of list.foodImages">
                <img loading="lazy" src="{{ imgUrl }}{{ img.image }}" />
              </ng-container>
              <div class="card--content__price">${{ list.memberPrice }}</div>
              <div class="card--content__desc">
                {{ list.description.substr(0, 100)
                }}<span *ngIf="list.description.length > 100">...</span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</section>
<section
  *ngIf="get_selected_products_listing_length != 0"
  class="item_details owl_nav_blue {{ shop_template }}"
>
  <div class="container-fluid px-md-4 px-lg-5">
    <!-- <h6 class="px-4 mt-4">FEATURED PRODUCTS</h6> -->
    <div class="row px-md-2 px-lg-2 mt-md-3 mt-lg-3 mt-3 mb-1">
      <div class="col-md-12">
        <nz-tabset nzType="card">
          <nz-tab [nzTitle]="'FEATURED'"> </nz-tab>
        </nz-tabset>
      </div>
    </div>

    <!-- <div class="pro_ser_fil">
      <input type="text" class="form-control pro_ser" placeholder="Search" [ngModel]="searchText" (ngModelChange)="searchKey($event)">
    </div> -->

    <!-- <p class="coming_soon" *ngIf="get_selected_products_listing_length == 0"><img loading="lazy"
        src="../../../../assets/images/new/coming-soon.png"></p> -->

    <owl-carousel-o [options]="customOptions">
      <ng-container *ngFor="let list of get_selected_products_listing">
        <ng-template class="slide" carouselSlide [id]="list.id">
          <div
            class="item_img"
            (click)="editProductModal(editProduct, list)"
          >
            <!-- <p>{{list.name}}</p> -->
            <img loading="lazy" src="{{ imgUrl }}{{ list.foodImages[0].image }}" />
            <!-- <img loading="lazy" src="https://buffer.com/cdn-cgi/image/w=1000,fit=contain,q=90,f=auto/library/content/images/size/w600/2023/10/free-images.jpg"> -->
            <p class="px-1 mt-1">{{ list.name }}</p>
          </div>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </div>
</section>

<app-customer-bottom-banner
  [shop_template]="shop_template"
></app-customer-bottom-banner>
<!-- Not in Use -->
<ng-template #editProduct let-modal>
  <div
    id="add_prod_detail"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class=""></div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <div class="add_cattt">
            <!-- <h5 class="mb-3">Product Details</h5> -->
            <i
              class="fa-regular fa-circle-xmark fa-2x"
              (click)="modalService.dismissAll()"
            ></i>
          </div>
          <div class="col-md-12 product_detail_body">
            <div class="d-flex justify-content-center flex-md-row flex-column">
              <img loading="lazy"
                class="image-active mb-2"
                src="{{ imgUrl }}{{ food_image_active }}"
              />
              <div class="mb-4">
                <div
                  class="d-flex flex-row flex-md-column justify-content-center"
                >
                  <img loading="lazy"
                    class="thumbnail-img"
                    *ngIf="food_image_1 != ''"
                    (click)="changeShowImageProduct(food_image_1)"
                    src="{{ imgUrl }}{{ food_image_1 }}"
                  />
                  <img loading="lazy"
                    class="thumbnail-img"
                    *ngIf="food_image_2 != ''"
                    (click)="changeShowImageProduct(food_image_2)"
                    src="{{ imgUrl }}{{ food_image_2 }}"
                  />
                  <img loading="lazy"
                    class="thumbnail-img"
                    *ngIf="food_image_3 != ''"
                    (click)="changeShowImageProduct(food_image_3)"
                    src="{{ imgUrl }}{{ food_image_3 }}"
                  />
                  <img loading="lazy"
                    class="thumbnail-img"
                    *ngIf="food_image_4 != ''"
                    (click)="changeShowImageProduct(food_image_4)"
                    src="{{ imgUrl }}{{ food_image_4 }}"
                  />
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-8 mb-3">
                <p class="mt-2 title">{{ food_details?.name }}</p>
                <p
                  class="mt-4 desc"
                  [innerText]="food_details?.description"
                ></p>
              </div>
              <div
                class="col-md-4 pl-md-4 pl-0 contact-seller"
                style="border-left: 1px solid grey"
              >
                <button
                  class="btn btn-sm btn-danger w-100"
                  (click)="redirectLink(food_details?.chat_url)"
                >
                  Chat
                </button>
                <small class="text-danger" *ngIf="errorChatURL"
                  >Contact Seller Via Other Methods</small
                >
                <br />
                <br />
                <div *ngIf="userProductBooking">
                  <b> Booked Date : </b>
                  {{ userProductBooking | date : "dd-MM-yyyy HH:mm" }}
                </div>
                <!--  -->
                <button
                  *ngIf="!userProductBooking && allowBooking"
                  class="btn btn-sm btn-primary w-100 bookNow"
                  (click)="openBookingModal(bookingModal)"
                  [disabled]="isLogin === 0"
                  [title]="isLogin === 0 ? 'You need to login' : ''"
                >
                  BOOK NOW
                </button>

                <button
                  *ngIf="userProductBooking && allowBooking"
                  class="btn btn-sm btn-primary w-100 bookNow"
                  (click)="openBookingModal(bookingModal)"
                  [disabled]="isLogin === 0"
                  [title]="isLogin === 0 ? 'You need to login' : ''"
                >
                  EDIT BOOKING
                </button>

                <div id="sellerInfoText" class="mt-4"></div>
              </div>
            </div>
            <div class="mt-4 px-0" *ngIf="food_details?.foodSpecs?.length > 0">
              <p class="mb-2">PRODUCT VARIANTS</p>
              <table class="table table-sm">
                <thead>
                  <tr class="text-nowrap">
                    <th scope="col" width="10px">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Details</th>
                    <th scope="col" width="15%">Price</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let variants of food_details?.foodSpecs">
                    <th scope="row">
                      <input
                        type="radio"
                        id="customRadioInline1_{{ variants?.id }}"
                        name="foodSpecs"
                        class="custom-control-input"
                        (change)="getFoodSpecs(variants?.id, food_details?.id)"
                      />
                      <label
                        class="custom-control-label spec_key_options"
                        for="customRadioInline1_{{ variants?.id }}"
                      ></label>
                    </th>
                    <td>{{ variants.value }}</td>
                    <td>{{ variants.nKey ? variants.nKey : "-" }}</td>
                    <td>${{ variants.key }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="add_cart mt-4 mb-4">
              <!-- <a (click)="isLogin == 1 ? add_to_cart(food_details.id) : openShopSigninPopup(shopSigninPopup)" class="add_to_cart_btn"> Add To Cart </a> -->
              <a
                (click)="add_to_cart($event, food_details.id)"
                class="add_to_cart_btn"
              >
                Add To Cart
              </a>
              <a
                (click)="openCartPopup($event, cartPopup)"
                class="go_to_cart_btn mt-2"
              >
                Go To Cart
              </a>
            </div>

            <div class="main-container-review">
              <h2>Reviews</h2>
              <owl-carousel-o [options]="customOptions">
                <ng-container *ngFor="let review of reviews_list">
                  <ng-template
                    class="slide review-item-container"
                    carouselSlide
                    [id]="review.id"
                  >
                    <div class="review-container">
                      <div class="top">
                        <div
                          class="right"
                          *ngIf="
                            review.image != '' && review.image != 'undefined'
                          "
                        >
                          <img loading="lazy"
                            [src]="this.baseUrlImgae + review.image"
                            alt="user image"
                          />
                        </div>
                        <div class="left pl-3">
                          <p>{{ review.userName }}</p>
                          <p class="date">
                            {{ review.createdAt * 1000 | date : "longDate" }}
                          </p>
                        </div>
                      </div>
                      <div class="mt-2 d-flex">
                        <div *ngFor="let num of rating_array">
                          <i
                            [class]="
                              num <= review.rating
                                ? 'fa fa-star'
                                : 'fa-regular fa-star'
                            "
                            aria-hidden="true"
                            class="star-rating-icon"
                            style="color: '#FDCC0D'"
                          ></i>
                        </div>
                      </div>
                      <div class="body pt-1">
                        {{ review.comment }}
                      </div>
                    </div>
                  </ng-template>
                </ng-container>
              </owl-carousel-o>
              <div *ngIf="reviews_list.length < 1">
                <div class="alert alert-light text-center" role="alert">
                  <i class="fa-regular fa-comment-alt"></i> There are no reviews
                  at this time
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<!-- Not In User -->
<app-marketplace #marketplace [share]="true"></app-marketplace>

<ng-template #confirmPayment let-modal>
  <div class="modal-content">
    <div class=""></div>
    <div class="modal-body">
      <form [formGroup]="confirm_payment_form">
        <div class="col-md-12">
          <div class="">
            <h2 class="cart_title">Confirm Payment</h2>
          </div>
        </div>
        <div class="con_cart_pop mb-3">
          <!-- <a class="description_btn" [ngClass]="{'active' : '1' == selectedPaymentMethod}"
            (click)="selectPaymentMethod('1')"> C.O.D </a> -->
          <!-- <small> + $3.50 Ninja Van</small> -->
          <!-- <a class="description_btn" [ngClass]="{'active' : '2' == selectedPaymentMethod}"
            (click)="selectPaymentMethod('2')"> Pay now </a> -->
          <img loading="lazy" src="../../../assets/images/new/paynow.png" />
          <!-- <small> + $3.50 Ninja Van</small> -->
          <!-- <a class="description_btn" [ngClass]="{'active' : '3' == selectedPaymentMethod}"
            (click)="selectPaymentMethod('3')">Pick Up </a> -->
        </div>

        <div class="col-md-12">
          <div class="form-group">
            <input
              type="text"
              placeholder="Name"
              class="form-control"
              formControlName="name"
            />
            <ng-container *ngIf="submitted && confirmPaymentErr.name.errors">
              <p
                class="error-message-repair"
                *ngIf="confirmPaymentErr.name.errors.required"
              >
                Name is required!
              </p>
            </ng-container>
          </div>
          <div class="form-group">
            <input
              type="text"
              placeholder="Phone Number"
              class="form-control"
              formControlName="unit"
              *ngIf="isLogin == 1"
            />
            <input
              type="text"
              placeholder="Phone Number"
              class="form-control"
              formControlName="unit"
              *ngIf="isLogin == 0"
            />
            <ng-container *ngIf="submitted && confirmPaymentErr.unit.errors">
              <p
                class="error-message-repair"
                *ngIf="confirmPaymentErr.unit.errors.required"
              >
                Phone Number is required!
              </p>
            </ng-container>
          </div>
          <div class="form-group">
            <input
              type="text"
              placeholder="Address"
              class="form-control"
              formControlName="address"
            />
            <ng-container *ngIf="submitted && confirmPaymentErr.address.errors">
              <p
                class="error-message-repair"
                *ngIf="confirmPaymentErr.address.errors.required"
              >
                Address is required!
              </p>
            </ng-container>
          </div>
          <div class="form-group">
            <input
              type="text"
              placeholder="Postal Code"
              class="form-control"
              formControlName="postalCode"
            />
            <ng-container
              *ngIf="submitted && confirmPaymentErr.postalCode.errors"
            >
              <p
                class="error-message-repair"
                *ngIf="confirmPaymentErr.postalCode.errors.required"
              >
                Postal Code is required!
              </p>
            </ng-container>
          </div>
          <div
            class="text-center mt-3 px-2"
            *ngIf="cart_total_response_length != 0"
          >
            <h5>
              <b>Total: ${{ cart_total }}</b>
            </h5>
          </div>
          <div class="col-md-12 mt-4">
            <div class="cart_btn">
              <a
                (click)="open_screenshot_upload_popup(screenshot_upload_popup)"
                class="confirm_button"
                >Confirm
              </a>
              <a
                (click)="cancel_confirm_payment_button(cartPopup)"
                class="cancel_button"
                >Cancel
              </a>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #cartPopup let-modal>
  <div
    id="cartPopup"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class=""></div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <div class="add_cattt">
            <i
              class="fa-regular fa-circle-xmark fa-2x"
              (click)="modalService.dismissAll()"
            ></i>
          </div>
          <div class="">
            <h2 class="cart_title">CART</h2>
          </div>
        </div>
        <div class="col-md-12">
          <div class="cart_table_one">
            <div class="table-content table-responsive cart-table-content">
              <table>
                <thead>
                  <tr>
                    <!-- <th>S.No.</th> -->
                    <th>Image</th>
                    <th>Item Name</th>
                    <th>Variant</th>
                    <th>Remarks</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let cart of cart_listing_response; let i = index">
                    <!-- <td>{{ i + 1 }}</td> -->
                    <td class="product-thumbnail">
                      <a
                        ><img loading="lazy"
                          src="{{ imgUrl }}{{ cart.food.foodImages[0].image }}"
                          alt=""
                      /></a>
                    </td>
                    <td class="product-name">{{ cart.food.name }}</td>
                    <td class="food-spec">{{ cart.foodSpecLeft }}</td>
                    <td class="food-remark">
                      <textarea
                        class="form-control"
                        (keyup)="
                          updateCartRemarks($event.target.value, cart.id)
                        "
                        maxlength="250"
                        >{{ cart.remarks }}</textarea
                      >
                    </td>
                    <td class="product-quantity">
                      <div class="cart-plus-minus">
                        <i
                          class="fas fa-minus cart_qty_dec"
                          (click)="inc_dec_qty(cart.id, '2')"
                        ></i>
                        <input
                          class="cart-plus-minus-box"
                          type="text"
                          name="qtybutton"
                          value="{{ cart.quantity }}"
                          readonly
                        />
                        <i
                          class="fas fa-plus cart_qty_inc"
                          (click)="inc_dec_qty(cart.id, '1')"
                        ></i>
                      </div>
                    </td>
                    <td class="product-price">
                      <p>${{ cart.foodSpecRight }}</p>
                    </td>
                    <td class="product-remove">
                      <a (click)="delete_cart_item(cart.id)"
                        ><i class="fas fa-times"></i
                      ></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p class="empty_cart mt-4" *ngIf="cart_total_response_length == 0">
              <img loading="lazy" src="../../../assets/images/new/empty_cart.png" />
            </p>
            <h2
              class="cart_empty_title"
              *ngIf="cart_total_response_length == 0"
            >
              Your cart is empty
            </h2>

            <div
              class="text-center mt-3 px-2"
              *ngIf="cart_total_response_length != 0"
            >
              <h6>
                <b>Total: ${{ cart_total }}</b>
              </h6>
            </div>

            <div class="cart_btn mt-3" *ngIf="cart_total_response_length != 0">
              <a
                (click)="confirmPaymentModal(confirmPayment)"
                class="confirm_button"
                >Confirm
              </a>
              <a (click)="modalDismissAll()" class="confirm_button">Cancel </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #orderHistoryPopup let-modal>
  <div
    id="orderHistory"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class=""></div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <div class="add_cattt">
            <i
              class="fa-regular fa-circle-xmark fa-2x"
              (click)="modalService.dismissAll()"
            ></i>
          </div>
          <div class="">
            <h2 class="cart_title">ORDER HISTORY</h2>
          </div>
        </div>
      </div>
      <p class="empty_cart mt-4" *ngIf="order_history_response_length == 0">
        <img loading="lazy" src="../../../assets/images/new/empty_cart.png" />
      </p>
      <h2 class="cart_empty_title" *ngIf="order_history_response_length == 0">
        You have no orders yet
      </h2>
      <div
        class="purchase_detail_item mb-4"
        *ngFor="let list of order_history_response; let i = index"
      >
        <!-- <h2> {{ i + 1 }} </h2> -->
        <div class="row">
          <div class="col-md-8">
            <div class="bg-white">
              <div class="table-content table-responsive cart-table-content">
                <table>
                  <thead>
                    <tr>
                      <!-- <th>S.No.</th> -->
                      <th>Image</th>
                      <th>Item Name</th>
                      <th>Variant</th>
                      <th>Qty</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let items of list.cartOrderItems; let i = index"
                    >
                      <!-- <td class="product-thumbnail">
                        {{ i + 1 }}
                      </td> -->
                      <td class="product-thumbnail">
                        <a
                          ><img loading="lazy"
                            src="{{ imgUrl }}{{
                              items.food.foodImages[0].image
                            }}"
                            alt=""
                        /></a>
                      </td>
                      <td class="product-name">
                        <a>{{ items.food.name }}</a>
                      </td>
                      <td>{{ items.foodSpecLeft }}</td>
                      <td class="product-quantity">
                        <div class="cart-plus-minus">
                          <input
                            class="cart-plus-minus-box"
                            type="text"
                            name="qtybutton"
                            value="{{ items.quantity }}"
                            readonly
                            disabled
                          />
                        </div>
                      </td>
                    </tr>
                    <tr></tr>
                  </tbody>
                </table>
              </div>
              <div class="item_total">
                <h5>
                  <b>Total: ${{ list.totalAmount }}</b>
                </h5>
                <div class="purchase_detail_right">
                  <a class="description_btn"> recieved</a>
                  <a class="description_btn">change</a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="purchase_right_side">
              <div class="purchase_detail_main">
                <div class="purchase_detail">
                  <p>Date:</p>
                  <Span> {{ list.created * 1000 | date : "medium" }} </Span>
                </div>
                <div class="purchase_detail">
                  <p>name:</p>
                  <Span> {{ list.cartTransaction.name }} </Span>
                </div>
                <div class="purchase_detail">
                  <p>phone:</p>
                  <Span> {{ list.cartTransaction.unit }}</Span>
                </div>
                <div class="purchase_detail">
                  <p>Address:</p>
                  <Span> {{ list.cartTransaction.address }} </Span>
                </div>
                <div class="purchase_detail">
                  <p>Postal code:</p>
                  <Span> {{ list.cartTransaction.postalCode }} </Span>
                </div>
              </div>
              <div class="cart_pop mt-3">
                <!-- <a class="description_btn" [ngClass]="{'active': list.cartTransaction.paymentType == 1}"> C.O.D </a> -->
                <a
                  class="description_btn"
                  [ngClass]="{ active: list.cartTransaction.paymentType == 2 }"
                >
                  Pay now
                </a>
                <!-- <a class="description_btn" [ngClass]="{'active': list.cartTransaction.paymentType == 3}">Pick Up </a> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #shopSigninPopup let-modal>
  <div class="modal-content">
    <div class=""></div>
    <div class="modal-body">
      <form [formGroup]="shop_signin_form">
        <div class="row">
          <div class="col-md-12">
            <div class="add_cattt">
              <i
                class="fa-regular fa-circle-xmark fa-2x"
                (click)="modalService.dismissAll()"
              ></i>
            </div>
            <div class="">
              <h2 class="cart_title">Signin</h2>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-12">
            <!-- <div class="form-group">
              <input type="text" placeholder="Name" class="form-control" formControlName="name">
              <ng-container *ngIf="submitted && shopSigninV.name.errors">
                <p class="error-message-repair" *ngIf=" shopSigninV.name.errors.required">
                  Name is required!
                </p>
              </ng-container>
            </div> -->
            <div class="form-group">
              <input
                type="text"
                placeholder="Phone Number"
                class="form-control"
                formControlName="phone_number"
              />
              <ng-container
                *ngIf="submitted && shopSigninV.phone_number.errors"
              >
                <p
                  class="error-message-repair"
                  *ngIf="shopSigninV.phone_number.errors.required"
                >
                  Phone Number is required!
                </p>
              </ng-container>
              <ng-container
                *ngIf="submitted && shopSigninV.phone_number.errors"
              >
                <p
                  class="error-message-repair"
                  *ngIf="shopSigninV.phone_number.errors.pattern"
                >
                  Enter valid phone number!
                </p>
              </ng-container>
              <ng-container
                *ngIf="submitted && shopSigninV.phone_number.errors"
              >
                <p
                  class="error-message-repair"
                  *ngIf="shopSigninV.phone_number.errors.minlength"
                >
                  Invalid phone number!
                </p>
              </ng-container>
              <ng-container
                *ngIf="submitted && shopSigninV.phone_number.errors"
              >
                <p
                  class="error-message-repair"
                  *ngIf="shopSigninV.phone_number.errors.maxlength"
                >
                  Invalid phone number!
                </p>
              </ng-container>
            </div>
            <!-- <div class="form-group">
              <input type="text" placeholder="Email" class="form-control" formControlName="email">
              <ng-container *ngIf="submitted && shopSigninV.email.errors">
                <p class="error-message-repair" *ngIf=" shopSigninV.email.errors.required">
                  Email is required!
                </p>
              </ng-container>
            </div> -->
          </div>
          <div class="col-md-12 mt-4">
            <div class="cart_btn">
              <a (click)="shop_sign_in()" class="confirm_button">Enter </a>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #shopSignoutPopup let-modal>
  <div class="modal-content">
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <div class="">
            <h2 class="cart_title mb-2">Are you sure ?</h2>
            <p class="text-center">You want to logout from the website.</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="cart_btn mt-4">
            <a (click)="shopLogout()" class="confirm_button">Yes </a>
            <a (click)="modalDismissAll()" class="confirm_button">No </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #memberLinkPopup let-modal>
  <div class="modal-body referral-modal">
    <div class="add_cattt">
      <h2>MEMBER INFO</h2>
      <img loading="lazy"
        src="../../../assets/images/close-icon.svg"
        alt="img"
        (click)="modalService.dismissAll()"
      />
    </div>
    <div class="gold-membership">
      <div>
        <img loading="lazy" src="../../../assets/images/GoldMember.png" alt="img" />
        <p>Gold</p>
      </div>
    </div>
    <div class="vouncher-card-wrap">
      <ngb-carousel *ngIf="activateVoucherList?.length > 0">
        <ng-template ngbSlide *ngFor="let voucher of activateVoucherList">
          <ngb-slide>
            <div class="vouncher-card-content">
              <div class="vouncher-card-title">
                <div class="vouncherCard">
                  <div class="vouncherCardImg">
                    <img loading="lazy"
                      src="{{ imgUrl }}{{ voucher.voucherImage }}"
                      alt="img"
                    />
                  </div>
                  <div class="vouncherCardDetails">
                    <h2 class="vouncherCardheading">
                      {{ voucher.voucherName }}
                    </h2>
                    <p class="vouncherCardcode">{{ voucher.voucherCode }}</p>
                    <button
                      *ngIf="!voucher.status"
                      (click)="openModal(voucher)"
                    >
                      Redeem
                    </button>
                    <button
                      class="disabled-button"
                      *ngIf="voucher.status"
                      disabled
                    >
                      Redeemed!
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ngb-slide>
        </ng-template>
      </ngb-carousel>
      <!-- <div class="vouncher-card-content" *ngFor="let voucher of activateVoucherList">
        <div class="vouncher-card-title">
          <h2>{{voucher.voucherCode}}</h2>
        </div>
        <button>redeem</button>
      </div> -->
    </div>
    <owl-carousel-o [options]="customOptions2" class="copy-code-card">
      <ng-container>
        <ng-template carouselSlide>
          <div class="vouncher-card-content">
            <div class="vouncher-card-title">
              <h2>JOY25</h2>
              <!-- <div class="copy-code">Copy Code</div> -->
            </div>
            <!-- <span>Enter this code at checkout</span> -->
          </div>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
    <div class="referral-link">
      <h6>REFERRAL LINK</h6>
      <div class="">
        <a class="referral-title" href="{{ referralLink }}" target="_blank">
          <p class="ref_link">{{ referralLink }}</p>
        </a>
      </div>
      <div class="mt-4">
        <div class="cart_btn">
          <a class="confirm_button" (click)="copyReferralLink()">
            <img loading="lazy" src="../../../assets/images/copy-icon.svg" alt="img" />
            Copy</a
          >
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #screenshot_upload_popup let-modal>
  <div class="modal-content">
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <div class="add_cattt">
            <i
              class="fa-regular fa-circle-xmark fa-2x"
              (click)="modalService.dismissAll()"
            ></i>
          </div>
          <div class="">
            <h2 class="cart_title">PAY NOW</h2>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 text-center">
          <p class="qr_text">{{ qr_text }}</p>
          <div class="qr_copy">
            <img loading="lazy" src="{{ imgUrl }}{{ shop_qr_image }}" width="150" />
            <i class="fa-regular fa-copy" title="Download"></i>
          </div>
        </div>
        <div class="col-md-12 text-center mt-3">
          <div class="form-group prod_upld">
            <p>Upload Screenshot</p>
            <input
              type="file"
              #file1
              (change)="onImageSelected(file1.files, $event)"
              accept="image/*"
            />
            <img loading="lazy"
              src="../../../assets/images/uploadd2.png"
              *ngIf="screenshot_image_show != 1"
              class="food_img"
            />
            <img loading="lazy"
              src="{{ screenshot_image_url }}"
              *ngIf="screenshot_image_url && screenshot_image_show == 1"
              class="screenshot_img"
            />
          </div>
        </div>
        <div class="col-md-12 mt-2">
          <div class="cart_btn">
            <a
              class="confirm_button_dis"
              *ngIf="isConfirmEnable == 0"
              style="margin: 0"
              >Confirm</a
            >
            <a
              (click)="confirm_payment_submit()"
              class="confirm_button"
              *ngIf="isConfirmEnable == 1"
              style="margin: 0"
              >Confirm
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #myModal let-modal>
  <div style="text-align: center">
    <div class="scenner">
      <h2>Scanner</h2>
    </div>
    <div>
      <ngx-scanner-qrcode
        id="scannerModal"
        class="custom-video"
        #action="scanner"
        [config]="config"
        (event)="onEvent($event, action)"
      ></ngx-scanner-qrcode>
      <button
        class="btn scennerButton"
        [class.btn-info]="!action.isStart"
        [class.btn-warning]="action.isStart"
        [disabled]="action.isLoading"
        (click)="handle(action, action.isStart ? 'stop' : 'start')"
      >
        <img loading="lazy"
          [src]="
            action.isStart
              ? 'https://id1945.github.io/images/svg/camera-off.svg'
              : 'https://id1945.github.io/images/svg/camera-on.svg'
          "
          width="30px"
        />
      </button>
      <br />
    </div>
  </div>
  <div class="snapshot" *ngIf="webcamImage">
    <img loading="lazy" [src]="webcamImage.imageAsDataUrl" />
  </div>
</ng-template>
<ng-template #myModalQr let-modal>
  <div class="qrmodal">
    <div style="text-align: center">
      <div>
        <div class="qrcodeHeading">
          <h2>Scan QR</h2>
        </div>
        <qrcode #qrCodeImage [elementType]="elementType" [qrdata]="QrCodeValue" cssClass="bshadow" [errorCorrectionLevel]="'M'"></qrcode>
      </div>
    </div>
    <div class="snapshot" *ngIf="webcamImage">
      <img loading="lazy" [src]="webcamImage.imageAsDataUrl" />
    </div>
  </div>
</ng-template>

<ng-template #infoModal let-modal>
  <div class="modal-content enhanced-modal">
    <button
      type="button"
      class="close-btn"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="modal-body enhanced-modal-body">
      <div class="image-container text-center">
        <img loading="lazy"
          src="../../../assets/images/uploadd2.png"
          *ngIf="!shop_banner"
          alt="Default Image"
          class="shop-img default-image"
        />
        <img loading="lazy"
          *ngIf="shop_banner"
          [src]="imgUrl + shop_banner"
          alt="Shop Banner"
          class="shop-img uploaded-image"
        />
      </div>
      <div class="description-container">
        <p class="shop-description">{{ shop_description }}</p>
      </div>
    </div>
  </div>
</ng-template>

<!-- BOOKING MODAL -->

<ng-template #bookingModal let-modal>
  <div class="modal-content d-flex justify-content-center align-items-center">
    <div class="modal-body text-center">
      <h2 class="cart_title mb-2">BOOK NOW</h2>

      <ngb-datepicker
        #dp
        [(ngModel)]="model"
        [minDate]="{
          year: today.getFullYear(),
          month: today.getMonth() + 1,
          day: today.getDate() + 1
        }"
        [markDisabled]="isDisabled"
        (navigate)="date = $event.next"
        (ngModelChange)="showFormattedDateTime()"
        class="mx-auto"
      ></ngb-datepicker>

      <ngb-timepicker
        [(ngModel)]="time"
        [meridian]="meridian"
        (ngModelChange)="showFormattedDateTime()"
        class="mx-auto mt-3"
      ></ngb-timepicker>

      <div class="cart_btn mt-4 d-flex justify-content-center">
        <a class="confirm_button" (click)="addBooking()">BOOK NOW</a>
        <a (click)="modal2DismissAll()" class="confirm_button ml-2">Cancel</a>
      </div>
    </div>
  </div>
</ng-template>
